import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AdminDashboard from './pages/AdminDashboard';
import './styles/App.css';
import PrivacyPolicy from './components/PrivacyPolicy'; // Add this import\
import TermsPage from './components/TermsPage'; // Add this import
import RefundPage from './components/RefundPage'; // Add this import
import PaymentConfirmation from './pages/PaymentConfirmation'; // Add this import

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dipadminv" element={<AdminDashboard />} />
          <Route path="/privacy" element={<PrivacyPolicy />} /> 
          <Route path="/terms" element={<TermsPage />} /> 
          <Route path="/seco" element={<PaymentConfirmation />} /> 
          <Route path="/refund" element={<RefundPage />} /> 
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;